// Base URL of the GroupLyrics API. Override it for local development with a .env.local file:
//   VITE_API_URL=https://localhost:5001
export const apiBaseUrl = (import.meta.env.VITE_API_URL || "https://api.sing.at").replace(/\/+$/, "");

// Session join codes are short alphanumeric strings, e.g. "MITKA".
export const SESSION_CODE_LENGTH = 5;

export const normalizeSessionCode = (value) =>
  (value || "").replace(/[^A-Za-z0-9]/g, "").toUpperCase();

export const isValidSessionCode = (value) => /^[A-Z0-9]{5}$/.test(value || "");
